import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditAccountFeeComp from "./Component/EditAccountFeeComp"


const EditAccountFee =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditAccountFeeComp />
        </div>
        <Footer />
        </>
    )
}

export default EditAccountFee